export default "/assets/images/cooking.png?4121ab8ff11267348f9b5a7c5924ce44";